var include_campaign_banners = `
<ul class="banner-slider js-banner__slider">
	<li>
		<a href="https://www.itoyokado.co.jp/special/nanaco_cp/index.html" class="Nanaco_TopCampaign" target="_blank">
			<div class="banner-contents">
				<div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_iy_happy_day2205_c.png" alt="ハッピーデーは事前チャージがおトク!イトーヨーカドーnanacoチャージキャンペーン"></div>
				<div class="banner-detail">
					<p class="banner-detail__text">2022年5月8日(日)～</p>
				</div>
			</div>
		</a>
	</li>
	<li>
		<a href="https://www.7-insurance.jp/lp/campaign/?utm_source=nanaco&utm_medium=WEB&utm_campaign=banner202406" class="Nanaco_TopCampaign" target="_blank">
			<div class="banner-contents">
				<div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_7insurance2406_c.jpg" alt="保険の資料請求orお申込みでセブン‐イレブンで対象の商品と交換できるデジタルギフトをもれなくプレゼント!"></div>
				<div class="banner-detail"></p>
					<p class="banner-detail__text">2024年6月1日(土)～2024年8月31日(土)</p>
				</div>
			</div>
		</a>
	</li>
	<li>
		<a href="https://www.sevenbank.co.jp/oos/adv/tmp_95.html?utm_source=ad&utm_medium=WEB&utm_campaign=hp_231201" class="Nanaco_TopCampaign" target="_blank">
			<div class="banner-contents">
				<div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_point_svenbank2312_c.png" alt="セブン銀行口座「ポイントサービス」給与 賞与 初回受取り特典 500ポイントプレゼント"></div>
				<div class="banner-detail"></p>
					<p class="banner-detail__text">2023年12月1日(金)～</p>
				</div>
			</div>
		</a>
	</li>
	<li>
		<a href="/how-to/guide/guide_beginner.html" class="Nanaco_TopCampaign">
			<div class="banner-contents">
				<div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_guide_app2404_c.png" alt="ご利用までの手順はたったの2つ!nanacoアプリはじめてのガイド"></div>
				<div class="banner-detail">
					<p class="banner-detail__text">2024年4月1日(月)～</p>
				</div>
			</div>
		</a>
	</li>
	<li>
		<a href="/information/mynumbercardpoint_2310.html" class="Nanaco_TopCampaign">
			<div class="banner-contents">
				<div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_mynumbercardpoint_2310_c.png" alt="nanacoでもらおう!!自治体マイナポイント nanacoはメリットいっぱい かんたん発行・お近くのセブン‐イレブンで・ご自身のスマートフォンで簡単即日発行 豊富な利用先 セブン&アイグループはじめ全国100万店以上で利用可能 最短2日後付与 申込完了後2日後の付与※自治体の施策によって異なる場合があります"></div>
				<div class="banner-detail"></p>
					<p class="banner-detail__text">2023年10月16日(月)～</p>
				</div>
			</div>
		</a>
	</li>
	<li>
		<a href="/cp/pointcp.html" class="Nanaco_TopCampaign">
			<div class="banner-contents">
				<div class="banner-thumbnail"><img src="/material/img/common/bnr/bnr_pointcp.png" alt="ポイントアップキャンペーン実施中"></div>
				<div class="banner-detail">
					<p class="banner-detail__icon">セブン・カードサービス</p>
					<p class="banner-detail__text"></p>
				</div>
			</div>
		</a>
	</li>
</ul>
`;
